import { initArticleTitleScale } from "./components/article-title-scale";
import { initCookiebot } from "./components/cookiebot";
import { initCopyLinks } from "./components/copy-link";
import { initVideoPlayer } from "./components/employee-grid-video";
import { initEmployeeSearch } from "./components/employee-search";
import { initEmployeesViewToggler } from "./components/employees-view-toggler";
import { initEventFeedSearch } from "./components/eventfeed-search";
import { initGalleryCarousel } from "./components/gallery-carousel";
import { initHomeLogo } from "./components/home-logo";
import { initNavigation } from "./components/navigation";
import { initNewsFeedSearch } from "./components/newsfeed-search";
import { initQuotes } from "./components/quotes";
import { initRollingText } from "./components/rolling-text";
import { initSectionAnimateIn } from "./components/section-animate-in";
import { initShareContent } from "./components/share-content";
import { initSentry } from "./sentry";

if (import.meta.env.DEV) {
    const { enableDevGrid } = await import("./components/dev-grid");
    enableDevGrid();
}

initSentry();
initEventFeedSearch();
initNewsFeedSearch();
initEmployeeSearch();
initShareContent();
initRollingText();
initNavigation();
initCopyLinks();
initGalleryCarousel();
initQuotes();
initVideoPlayer();
initArticleTitleScale();
initSectionAnimateIn();
initCookiebot();
initEmployeesViewToggler();
initHomeLogo();
